import React from 'react';
import {Select} from 'antd';
import commonExtendsHOC from '../../commonExtendsHOC';

const {Option}=Select;
export default commonExtendsHOC(Select);
export const AisinoOption= commonExtendsHOC(Option);
